import { Fragment, useState } from "react";
import { Popover, Transition } from "@headlessui/react";
import QRCode from "react-qr-code";

const HeaderV2 = () => {
  const [isModalVisible, setModalVisible] = useState(false);

  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  return (
    <>
      <nav className="w-full">
        <div className="container">
          <div className="flex items-center justify-center lg:justify-between py-8 lg:py-10 bg-white">
            {/* logo */}
            <div className="flex">
              <a href="/">
                <span className="sr-only">Yantra</span>
                <svg
                  width="156"
                  height="24"
                  viewBox="0 0 156 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M40.7462 3.60156L45.9262 11.5216L51.1569 3.60156H54.9938L47.5385 14.1246V22.1H44.2769V14.1246L36.8215 3.60156H40.7462Z"
                    fill="#102B68"
                  />
                  <path
                    d="M56.7523 22.1H53.1908L59.6923 5.65696C60.3769 3.92926 61.6385 3.27234 63.5846 3.27234C65.5031 3.27234 66.7631 3.92926 67.4215 5.65696L73.6708 22.1H70.0738L64.4615 7.2185C64.405 7.02616 64.2845 6.85886 64.12 6.74419C63.9556 6.62952 63.757 6.57433 63.5569 6.58773C63.3542 6.57767 63.1536 6.63374 62.9855 6.7475C62.8173 6.86126 62.6907 7.02655 62.6246 7.2185L56.7523 22.1Z"
                    fill="#102B68"
                  />
                  <path
                    d="M79.6108 22.1H76.38V7.30157C76.38 4.88926 77.7508 3.27234 80.6277 3.27234C83.2046 3.27234 84.3554 4.58773 85.1231 6.6985L90.5231 18.5108C90.7416 18.9493 91.0985 19.28 91.7015 19.28C92.3862 19.28 92.7969 18.8677 92.7969 18.2385V3.60157H96.0585V18.3708C96.0585 20.8093 94.6616 22.4262 91.8108 22.4262C89.2339 22.4262 88.0554 21.1108 87.2892 19L81.8892 7.18773C81.6431 6.64003 81.3139 6.39388 80.7385 6.39388C79.9985 6.39388 79.6139 6.80465 79.6139 7.46157L79.6108 22.1Z"
                    fill="#102B68"
                  />
                  <path
                    d="M113.103 3.60156V6.83233H107.705V22.097H104.443V6.83541H99.0431V3.60464L113.103 3.60156Z"
                    fill="#102B68"
                  />
                  <path
                    d="M126.122 3.60156C130.288 3.60156 132.069 6.17695 132.069 9.14003C132.069 11.4477 130.974 13.9093 128.151 14.7047L132.458 22.1031H128.863L124.642 14.9508H119.818C119.511 14.9508 119.357 15.0877 119.357 15.4123V22.0985H116.126V14.7831C116.126 12.7 117.003 11.8508 119.031 11.8508H126.24C128.075 11.8508 128.815 10.5893 128.815 9.27388C128.815 7.95849 128.022 6.83541 126.24 6.83541H116.091V3.60464L126.122 3.60156Z"
                    fill="#102B68"
                  />
                  <path
                    d="M137.551 22.1H133.988L140.483 5.65696C141.169 3.92926 142.429 3.27234 144.375 3.27234C146.294 3.27234 147.555 3.92926 148.212 5.65696L154.462 22.1H150.871L145.252 7.2185C145.196 7.02616 145.075 6.85886 144.911 6.74419C144.746 6.62952 144.548 6.57433 144.348 6.58773C144.146 6.5792 143.948 6.63603 143.781 6.74971C143.615 6.8634 143.49 7.02784 143.425 7.2185L137.551 22.1Z"
                    fill="#102B68"
                  />
                  <path
                    d="M15.4569 6.48617L10.4846 11.4662L5.57846 6.55079V8.65387H0.615387V3.33079C0.615386 2.87882 0.794719 2.44532 1.11402 2.12544C1.43332 1.80556 1.8665 1.62545 2.31846 1.62463H10.6031L15.4569 6.48617Z"
                    fill="#12C3F4"
                  />
                  <path
                    d="M30.1877 1.62463L10.5815 21.2631C10.2132 21.6329 9.77535 21.9263 9.29326 22.1264C8.81117 22.3265 8.29429 22.4295 7.77232 22.4293H0.660004V14.3754H5.58308V16.3754L10.4892 11.46L15.4616 6.48002L20.3077 1.62463H30.1877Z"
                    fill="#1F76CC"
                  />
                  <path
                    d="M26.6877 22.4292C28.6207 22.4292 30.1877 20.8622 30.1877 18.9292C30.1877 16.9962 28.6207 15.4292 26.6877 15.4292C24.7547 15.4292 23.1877 16.9962 23.1877 18.9292C23.1877 20.8622 24.7547 22.4292 26.6877 22.4292Z"
                    fill="#102B68"
                  />
                </svg>
              </a>
            </div>

            <Popover className="relative" static>
              {({ open }) => (
                <div onMouseLeave={closeModal} className="cursor-pointer">
                  <button
                    className={`${open ? "" : "text-opacity-90"} y-nav-qr`}
                    style={isModalVisible ? { background: "#f0f4f5" } : {}}
                    onMouseEnter={openModal}
                  >
                    <QRCode
                      value={window.location.origin + "/app"}
                      size={40}
                      className="y-app-qr"
                    />
                    <p className="ml-4 y-nav-text">Get Yantra App</p>
                  </button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                    show={isModalVisible}
                  >
                    <Popover.Panel className="y-nav-qr__pop-panel" static>
                      <div className="y-nav-qr__pop">
                        <p className="text-center">Scan to download the app</p>

                        <div className="mt-4">
                          <figure className="y-nav-qr__img">
                            <QRCode
                              value={window.location.origin + "/app"}
                              size={156}
                            />
                          </figure>
                        </div>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </div>
              )}
            </Popover>
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderV2;
